import { t } from '@lingui/macro';
import { i18n } from '@lingui/core';

import { ROW_TYPES } from '../Properties';
import { PageLink } from '../../links/Links';
import { isPresent } from '../funcs';

export default function radioProperty(radioName, radioId) {
    return {
        type: ROW_TYPES.FUNCTION,
        title: i18n._(t`Wi-Fi Radio`),
        hasValue: (data) => isPresent(data?.[radioName]) && isPresent(data?.[radioId]),
        mapper: (data) => {
            const { [radioName]: name, [radioId]: uuid } = data || {};

            if (!name || !uuid) return undefined;

            return <PageLink target="../radio-detail" targetName={name} filters={[{ name: 'Radio', uuid }]} />;
        },
    };
}
